/* eslint-disable no-await-in-loop */
import moment from 'moment';
import Swal from 'sweetalert2';
import { findIndex } from 'lodash';

import {
  MAN_SET_MANIFESTAR_FAIL,
  MAN_SET_MANIFESTAR_SUCCESS,
  MAN_SET_MANIFESTOS_FAIL,
  MAN_SET_MANIFESTOS_SUCCESS,
} from './types';
import box from '../api/box';
import { createSuccessNotification, sendErroRequest } from '../utils/Notification';

const urlBaseManifestos = '/v1/manifestos';

const obterDescricaoSituacaoManifesto = situacaoManifesto => {
  switch (situacaoManifesto) {
    case 2:
      return 'Ciência';
    case 3:
      return 'Confirmado';
    case 4:
      return 'Desconhecido';
    case 5:
      return 'Não Realizado';
    default:
      return 'Sem Manifesto';
  }
};

export const setManifestoSuccess = values => ({
  type: MAN_SET_MANIFESTOS_SUCCESS,
  payload: values,
});

export const setManifestoFail = () => ({
  type: MAN_SET_MANIFESTOS_FAIL,
});

export const setManifestarSuccess = () => ({
  type: MAN_SET_MANIFESTAR_SUCCESS,
});

export const setManifestarFail = () => ({
  type: MAN_SET_MANIFESTAR_FAIL,
});

export const getManifesto = (filtroForm, cb) => async dispatch => {
  try {
    const {
      initialDate,
      finalDate,
      documentKey,
      documentSituation,
      documentFiscalSituation,
    } = filtroForm;

    const filtroArray = [];

    if (initialDate)
      filtroArray.push({
        campo: 'dataEmissaoManifesto',
        valor: moment(initialDate).format('YYYYMMDD'),
        condicao: 'gte',
      });

    if (finalDate)
      filtroArray.push({
        campo: 'dataEmissaoManifesto',
        valor: moment(finalDate).format('YYYYMMDD'),
        condicao: 'lte',
      });

    if (documentKey) filtroArray.push({ campo: 'chaveDocumentoFiscal', valor: documentKey });

    if (documentSituation)
      filtroArray.push({ campo: 'situacaoManifesto', valor: documentSituation });

    if (documentFiscalSituation)
      filtroArray.push({ campo: 'situacaoDocumentoFiscal', valor: documentFiscalSituation });

    const params = {
      ...(filtroArray.length > 0 && { filtro: JSON.stringify(filtroArray) }),
    };

    const { data } = await box.get(urlBaseManifestos, { params });

    dispatch(setManifestoSuccess(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os Manifestos');

    dispatch(setManifestoFail());
  }
};

export const manifestar = (tipoManifestacao, manifestosSelecionados, cb) => async (
  dispatch,
  getState,
) => {
  try {
    const {
      manifesto: { manifestos },
    } = getState();

    const resultado = [];
    const manifestosAtualizados = [...manifestos];
    let justificativa;

    if (tipoManifestacao === 5) {
      justificativa = await Swal.fire({
        title: 'Informe a justificativa da manifestação',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Enviar justificativa',
        confirmButtonColor: '#0d519c',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        inputValidator: validaJustificativa,
      });
    }

    for (let index = 0; index < manifestosSelecionados.length; index += 1) {
      const manifestoSelecionado = manifestosSelecionados[index];

      const { chaveDocumentoFiscal, situacaoManifesto } = manifestoSelecionado;

      if (situacaoManifesto === 7) {
        resultado.push({
          manifestado: 'Não',
          chave: chaveDocumentoFiscal,
          mensagem: 'Não é possível manifestar documento cancelado.',
        });
      } else if (situacaoManifesto === 6 && tipoManifestacao === 2) {
        resultado.push({
          manifestado: 'Não',
          chave: chaveDocumentoFiscal,
          mensagem: 'Não é possível manifestar documento marcado com ciência automática.',
        });
      } else {
        const { data } = await box
          .post(`${urlBaseManifestos}/manifestar`, {
            tipoManifestacao,
            chaveDocumentoFiscal,
            ...(justificativa && { justificativa: justificativa.value }),
          })
          .catch(error => {
            throw new Error(error);
          });

        const { cStat, chNFe, xMotivo } = data.data.infEvento;

        resultado.push({
          manifestado: data.sucesso ? 'Sim' : 'Não',
          chave: chNFe,
          mensagem: cStat === '573' ? 'Confirmação efetuada' : xMotivo,
        });

        if (cStat === '575') {
          // Remove o documento da lista quando não pertence à empresa
          const filtered = manifestosAtualizados.filter(
            manifesto => manifesto.chaveDocumentoFiscal !== chNFe,
          );
          manifestosAtualizados.length = 0;
          manifestosAtualizados.push(...filtered);
        } else if (data.sucesso) {
          const i = findIndex(
            manifestosAtualizados,
            manifesto => manifesto.chaveDocumentoFiscal === chNFe,
          );

          if (i >= 0) {
            manifestosAtualizados[i] = {
              ...manifestosAtualizados[i],
              descricaoSituacaoManifesto: obterDescricaoSituacaoManifesto(tipoManifestacao),
              situacaoManifesto: tipoManifestacao,
              // Atualiza a situação do XML se retornada pelo backend
              ...(data.data.situacaoDocumentoFiscal && { situacaoDocumentoFiscal: data.data.situacaoDocumentoFiscal }),
              ...(data.data.descricaoSituacaoDocumentoFiscal && { descricaoSituacaoDocumentoFiscal: data.data.descricaoSituacaoDocumentoFiscal }),
            };
          }
        }
      }
    }

    dispatch(setManifestarSuccess());
    dispatch(setManifestoSuccess(manifestosAtualizados));

    if (cb && typeof cb === 'function') cb(resultado);
  } catch (error) {
    sendErroRequest(error, 'Não foi possível  Manifestar no momento, Tente novamente.');

    dispatch(setManifestarFail());
  }

  function validaJustificativa(value) {
    if (!value) return 'Campo obrigatório.';
    if (value.length < 15) return 'Campo deve ter no mínimo 15 caracteres.';
    if (value.length > 255) return 'Campo deve ter no máximo 255 caracteres.';
  }
};

export const voltarNSU = async voltarNSUDTO => {
  try {
    const { data } = await box.post(`${urlBaseManifestos}/voltar-nsu`, voltarNSUDTO);

    createSuccessNotification(data.mensagem || 'A operacao foi iniciada com sucesso e sera concluida em breve');
    return data;
  } catch (error) {
    sendErroRequest(error, 'Nao foi possivel voltar o NSU.');
    throw error;
  }
};

export const sincronizarStatus = async () => {
  try {
    const { data } = await box.post(`${urlBaseManifestos}/sincronizar-status`);
    createSuccessNotification(data.mensagem || 'Documentos sincronizados com sucesso.');
    return data;
  } catch (error) {
    sendErroRequest(error, 'Não foi possível sincronizar os documentos.');
    throw error;
  }
};
